import { animate, style, transition, trigger } from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [// NOSONAR
  transition(':enter', [style({ opacity: 0 }), animate(250)]),// NOSONAR
  transition('* => void', [// NOSONAR
    animate(// NOSONAR
      250,
      style({// NOSONAR
        opacity: 0
      })
    )
  ])
]);

export const fadeIn = trigger('fadeIn', [// NOSONAR
  transition(':enter', [style({ opacity: 0 }), animate(500)]),// NOSONAR
  transition(':leave', [style({ opacity: 0 }), animate(1)])// NOSONAR
]);
